import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {VetineoConfigurationService} from "../../providers/vetineo-configuration.service";
import {CheckVetineoConfigurationResponse} from "../../models/check-vetineo-configuration-response.model";
import {AppStateService} from "../../providers/app-state.service";
import {CommonUtils} from "../../utils/common";
import {ModalController} from "@ionic/angular";
import {Subscription} from "rxjs";
import {VetineoConfigurationError} from "../../models/vetineo-configuration-error.model";

@Component({
  selector: 'app-vetineo-configuration-check',
  templateUrl: './vetineo-configuration-check.component.html',
  styleUrls: ['./vetineo-configuration-check.component.scss'],
})
export class VetineoConfigurationCheckComponent implements OnInit, OnDestroy {

  @Input() uuid: string;
  vetineoConfiguration: CheckVetineoConfigurationResponse;
  private checkConfigurationSub: Subscription;
  @Input() clinicName: string;
  isBusy: boolean;
  sitesbiManualConfiguration: VetineoConfigurationError[];
  kxpManualConfiguration: VetineoConfigurationError[];
  private setConfigSub: Subscription;
  private isBusySub: Subscription;
  licenceKey: string;

  constructor(private vetineoConfigurationService: VetineoConfigurationService,
              private appStateService: AppStateService,
              private commonUtils: CommonUtils,
              private modalController: ModalController) {
  }

  ngOnInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });
  }

  checkConfiguration(withWidget: boolean) {
    this.appStateService.updateIsBusySubject(true);
    this.checkConfigurationSub = this.vetineoConfigurationService.checkVetineoConfiguration(this.uuid, withWidget).subscribe(e => {
      this.appStateService.updateIsBusySubject(false);
      if (e) {
        this.vetineoConfiguration = e;
      } else {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas sprawdzania konfiguracji');
      }

    }, error => {
      this.commonUtils.presentAlertToast('Wystąpił błąd podczas sprawdzania konfiguracji');
      this.appStateService.updateIsBusySubject(false);
    })
  }

  ngOnDestroy(): void {
    if (this.checkConfigurationSub) {
      this.checkConfigurationSub.unsubscribe();
    }
    if (this.setConfigSub) {
      this.setConfigSub.unsubscribe();
    }
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
  }


  setConfigurationInSitesbi(withWidget: boolean) {
    const withWidgetAddon = (withWidget ? ' (z widgetem)' : ' (bez widgetu)');
    this.commonUtils.presentYesNoActionSheet(`Na pewno chcesz ustawić konfigurację Vetineo${withWidgetAddon} w Sitesbi?`, 'Tak', 'Nie', 'checkmark', 'close', () => {
      this.appStateService.updateIsBusySubject(true);
      this.setConfigSub = this.vetineoConfigurationService.setVetineoSettingsInSitesbi(this.uuid, withWidget).subscribe(e => {
        this.appStateService.updateIsBusySubject(false);
        if (e) {
          this.sitesbiManualConfiguration = e.sitesbiResults;
          this.licenceKey = e.licenceKey;
        } else {
          this.commonUtils.presentAlertToast('Wystąpił błąd podczas zapisywania konfiguracji');
        }

      }, error => {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas zapisywania konfiguracji');
        this.appStateService.updateIsBusySubject(false);
      });
    }, () => {
    });
  }

  close() {
    this.modalController.dismiss();
  }

  setConfigurationInKXP() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz ustawić konfigurację Vetineo w KXP (MySQL)?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      this.appStateService.updateIsBusySubject(true);
      this.setConfigSub = this.vetineoConfigurationService.setVetineoSettingsInKXP(this.uuid).subscribe(e => {
        this.appStateService.updateIsBusySubject(false);
        if (e) {
          this.kxpManualConfiguration = e;
        } else {
          this.commonUtils.presentAlertToast('Wystąpił błąd podczas zapisywania konfiguracji');
        }

      }, error => {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas zapisywania konfiguracji');
        this.appStateService.updateIsBusySubject(false);
      })
    }, () => {
    });
  }
}
